import { FC } from "react";
import { FieldError } from "react-hook-form";

const getErrorDescription = ({ type, message }: FieldError) => {
  switch (type) {
    case 'required':
      return <p>This field is required</p>;
    default:
      return <p>{message}</p>;
  }
};

export const DefaultError: FC<FieldError> = error => {
  const description = getErrorDescription(error);
  return (
    <p className="relative mt-0.5 w-full rounded-md border-red-100 bg-red-50 px-1 py-2 text-center text-sm font-medium text-red-500">
      {description}
    </p>
  );
};